const ViewBaseConfig = Symbol.for("drizzle:ViewBaseConfig");
export {
  ViewBaseConfig
};
//# sourceMappingURL=view-common.js.map